import merge from 'lodash/merge'

export default function baseTextStyles({variant, color, linkColor, linkHoverColor }) {
  
  let jss = {}

  merge(jss, {
    '&': {
      color: color
    },
    '& a': {
      color: linkColor
    },
    '& a:hover': {
      color: linkHoverColor
    }
  })

  return jss
} 